var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMap',{ref:"map",staticStyle:{"width":"100%","height":"100%"},attrs:{"center":{ lat: parseFloat(_vm.data.lat), lng: parseFloat(_vm.data.lon) },"zoom":this.zoom,"map-type-id":"roadmap","options":{
    zoomControl: false,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    gestureHandling: 'cooperative',
    fullscreenControl: false,
    disableDefaultUI: false,
    styles: _vm.mapStyle,
  }}},[_c('GmapMarker',{attrs:{"position":_vm.google &&
        new _vm.google.maps.LatLng(parseFloat(_vm.data.lat), parseFloat(_vm.data.lon)),"clickable":true,"draggable":false},on:{"click":function($event){this.zoom = 15}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }